var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!true)?_c('div',[_c('member-detail-component',{attrs:{"member-type":'userProfile'}})],1):_c('div',[_c('member-detail-component',{attrs:{"member-type":'myProfile'}})],1),_c('filter-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }